// Central company data used across the marketing site.

export const COMPANY = {
  name: "MRL Transports",
  founded: 2007,
  yearsExperience: 25,
  city: "Namakkal",
  region: "Tamil Nadu",
  country: "India",
  address: "Namakkal, Tamil Nadu, India",
  leader: {
    name: "Mr. S. Madeswaran",
    title: "Founder & Managing Partner",
    experienceYears: 25,
  },
  offices: {
    corporate: {
      label: "Corporate Office",
      line1: "141/1, MRL Towers, Salem to Karur Bypass",
      line2: "Swamy Nagar, Mudhalipatti",
      city: "Namakkal, Tamil Nadu – 637003",
      country: "India",
      mapsQuery:
        "MRL Towers, Salem to Karur Bypass, Swamy Nagar, Mudhalipatti, Namakkal, Tamil Nadu 637003",
    },
    registered: {
      label: "Registered Office",
      line1: "7/28, Perumampalayam",
      line2: "Muthugapatti Post",
      city: "Namakkal, Tamil Nadu – 637405",
      country: "India",
    },
  },
  phones: [
    { label: "Primary", value: "+91 97900 16998", raw: "919790016998" },
    { label: "Operations", value: "+91 82200 47998", raw: "918220047998" },
    { label: "Enquiries", value: "+91 96298 16998", raw: "919629816998" },
  ],
  email: "mrltrans@yahoo.co.in",
  logoUrl: "/mrl-logo.png",
};

export const NAV_LINKS = [
  { label: "Home", to: "/" },
  { label: "About", to: "/about" },
  { label: "Services", to: "/services" },
  { label: "Fleet", to: "/fleet" },
  { label: "Clients", to: "/clients" },
  { label: "Certifications", to: "/certifications" },
  { label: "Contact", to: "/contact" },
];

export const WHY_CHOOSE = [
  {
    title: "Customized Vehicles",
    body: "Specialized vehicles configured to meet the unique transportation requirements of each project and client.",
    icon: "Truck",
  },
  {
    title: "25+ Years Experience",
    body: "Backed by over 25 years of experience in specialized transportation for India's wind energy sector.",
    icon: "Award",
  },
  {
    title: "Diverse Fleet",
    body: "A wide range of specialized vehicles and equipment capable of handling varied cargo dimensions.",
    icon: "Layers",
  },
  {
    title: "GPS / GPRS Tracking",
    body: "Modern GPS-enabled telematics for real-time vehicle monitoring, enhanced security and operational control.",
    icon: "Satellite",
  },
  {
    title: "Seamless Communication",
    body: "A well-organized communication process ensures coordination and timely updates throughout execution.",
    icon: "MessagesSquare",
  },
  {
    title: "Reliable Execution",
    body: "Committed to delivering transportation solutions safely, efficiently and on schedule — every time.",
    icon: "ShieldCheck",
  },
];

export const SERVICES = [
  {
    key: "route-survey",
    title: "Route Survey & Planning",
    summary:
      "End-to-end pre-movement route surveys, obstruction mapping, height/width clearance checks and detailed movement plans for over-dimensional cargo.",
    details: [
      "GPS-marked route recce with photo/video documentation",
      "Bridge, culvert and turning-radius clearance analysis",
      "Alternate route planning and risk assessment",
    ],
  },
  {
    key: "odc",
    title: "ODC Transportation",
    summary:
      "Safe and compliant movement of Over-Dimensional Cargo — wind turbine blades, nacelles, hubs, tower sections and heavy engineering components.",
    details: [
      "Specialized trailers configured to load geometry",
      "Escort teams and coordination with authorities",
      "Time-bound multi-state transit management",
    ],
  },
  {
    key: "inter-carting",
    title: "Inter-Carting Operations",
    summary:
      "Last-mile inter-carting of turbine components from lay-down yards to hill-top wind sites using purpose-built pullers and trailers.",
    details: [
      "Rugged terrain and gradient handling",
      "Site-specific loading configurations",
      "Coordinated cycle-time optimization",
    ],
  },
  {
    key: "project-logistics",
    title: "Project Logistics Management",
    summary:
      "Integrated project logistics covering scheduling, resource deployment, and multi-stakeholder coordination for large renewable energy roll-outs.",
    details: [
      "Dedicated project manager and control tower",
      "Resource planning across geographies",
      "Real-time reporting to client stakeholders",
    ],
  },
  {
    key: "site-coordination",
    title: "Site Coordination",
    summary:
      "On-ground execution support with dedicated site supervisors ensuring seamless interfaces between transport, cranes and erection teams.",
    details: [
      "Trained site coordinators",
      "Safety-first execution protocols",
      "Real-time issue resolution",
    ],
  },
  {
    key: "escort-permits",
    title: "Escort & Permit Management",
    summary:
      "Complete handling of state permits, RTO approvals, pilot escorts and traffic coordination for ODC and OWC movements across states.",
    details: [
      "Multi-state permit acquisition",
      "Police & traffic coordination",
      "Documentation and compliance archive",
    ],
  },
  {
    key: "loading-unloading",
    title: "Loading & Unloading Support",
    summary:
      "Skilled riggers, hydraulic jacking systems, mobile cranes and boom lifts for safe loading, discharge and lay-down yard operations.",
    details: [
      "Certified rigging crew",
      "Hydraulic and mechanical lifting equipment",
      "Yard management support",
    ],
  },
];

export const INDUSTRIES = [
  "Wind Energy",
  "Solar Energy",
  "Infrastructure Projects",
  "Heavy Engineering",
  "Power Sector",
];

export const FLEET = [
  {
    category: "Specialized Trailers",
    items: [
      { name: "Hydraulic Axle Trailers", spec: "Modular, ultra-heavy payload", icon: "Truck" },
      { name: "Blade Telescopic Trailers", spec: "Extendable for blade lengths 45–90 m", icon: "MoveHorizontal" },
      { name: "Tower Low-Bed Trailers", spec: "For tower sections up to Ø 4.5 m", icon: "TowerControl" },
      { name: "Semi Low-Bed Trailers", spec: "General ODC and heavy machinery", icon: "Container" },
      { name: "High-Bed Trailers", spec: "Long components and structural cargo", icon: "PackageOpen" },
      { name: "Multi-Axle Configurations", spec: "Custom axle lines for weight distribution", icon: "Layers" },
    ],
  },
  {
    category: "Prime Movers & Lifting",
    items: [
      { name: "Heavy-Duty Pullers", spec: "High-torque tractors for gradient sites", icon: "Zap" },
      { name: "Boom Lifts & Manlifts", spec: "Access equipment up to working heights", icon: "ArrowUpNarrowWide" },
      { name: "Heavy-Duty Mobile Cranes", spec: "For loading, discharge and erection support", icon: "Crane" },
    ],
  },
];

export const FLEET_SUPPORT = [
  "Escort Vehicles",
  "Mobile Maintenance Campers",
  "GPS / GPRS Fleet Tracking",
  "Dedicated Operations & Coordination Support",
];

export const CLIENTS = [
  "Suzlon Energy",
  "Vayona Energy",
  "JSW Energy",
  "Envision Energy",
  "Inox Wind",
  "Adani Power",
  "CleanMax",
  "ReNew",
  "Everrenew",
  "BHEL",
  "SARENS",
];

export const CERTIFICATIONS = [
  {
    code: "ISO 9001",
    title: "Quality Management System",
    body: "Consistent processes, measurable quality and continuous improvement in every transportation project we deliver.",
  },
  {
    code: "ISO 14001",
    title: "Environmental Management System",
    body: "Reducing environmental impact through responsible fleet operations, fuel efficiency and waste management practices.",
  },
  {
    code: "ISO 45001",
    title: "Occupational Health & Safety",
    body: "Safety-first culture protecting our people, partners and public across every transit route and project site.",
  },
];

export const IMAGES = {
  hero:
    "https://images.pexels.com/photos/14333501/pexels-photo-14333501.jpeg",
  heroSecondary:
    "https://images.unsplash.com/photo-1485575301924-6891ef935dcd?auto=format&fit=crop&w=1600&q=80",
  about:
    "https://images.pexels.com/photos/33370624/pexels-photo-33370624.jpeg",
  aboutTeam:
    "https://images.unsplash.com/photo-1548013146-72479768bada?auto=format&fit=crop&w=1600&q=80",
  serviceWind:
    "https://images.pexels.com/photos/33708758/pexels-photo-33708758.jpeg",
  serviceHeavy:
    "https://images.unsplash.com/photo-1485575301924-6891ef935dcd?auto=format&fit=crop&w=1600&q=80",
  fleet:
    "https://images.unsplash.com/photo-1592805144716-feeccccef5ac?auto=format&fit=crop&w=1600&q=80",
  fleetBlade:
    "https://images.pexels.com/photos/9800020/pexels-photo-9800020.jpeg",
  certifications:
    "https://images.unsplash.com/photo-1592395700302-d433884e8d45?auto=format&fit=crop&w=1600&q=80",
  contact:
    "https://images.unsplash.com/photo-1519003722824-194d4455a60c?auto=format&fit=crop&w=1600&q=80",
};
